<template>
  <div class="career">
    <view-layout
        :header="header[language]"
    >
      <career-steps />
    </view-layout>
  </div>
</template>

<script>
import ViewLayout from "../components/ViewLayout";
import CareerSteps from "../components/Career/CareerElements";

import {mapState} from "vuex";

export default {
  name: "Career",
  components: {
    ViewLayout,
    CareerSteps
  },
  computed: {
    ...mapState([
        "language"
    ])
  },
  data() {
    return {
      header: {
        "En": "My career",
        "Ru": "Моя карьера"
      }
    }
  }
}
</script>

<style scoped>

</style>